import { createStore } from 'stimulus-store';

export const deploymentStatusFilterOptionsStore = createStore({
    name: 'deploymentStatusFilterOptionsStore',
    type: Array,
    initialValue: []
});
